/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { KonturMercuryIcon16Light } from './KonturMercuryIcon16Light';
import { KonturMercuryIcon16Regular } from './KonturMercuryIcon16Regular';
import { KonturMercuryIcon16Solid } from './KonturMercuryIcon16Solid';
import { KonturMercuryIcon20Light } from './KonturMercuryIcon20Light';
import { KonturMercuryIcon20Regular } from './KonturMercuryIcon20Regular';
import { KonturMercuryIcon20Solid } from './KonturMercuryIcon20Solid';
import { KonturMercuryIcon24Regular } from './KonturMercuryIcon24Regular';
import { KonturMercuryIcon24Solid } from './KonturMercuryIcon24Solid';
import { KonturMercuryIcon32Regular } from './KonturMercuryIcon32Regular';
import { KonturMercuryIcon64Regular } from './KonturMercuryIcon64Regular';
var sizes = {
    16: {
        light: KonturMercuryIcon16Light,
        regular: KonturMercuryIcon16Regular,
        solid: KonturMercuryIcon16Solid,
    },
    20: {
        light: KonturMercuryIcon20Light,
        regular: KonturMercuryIcon20Regular,
        solid: KonturMercuryIcon20Solid,
    },
    24: {
        regular: KonturMercuryIcon24Regular,
        solid: KonturMercuryIcon24Solid,
    },
    32: {
        regular: KonturMercuryIcon32Regular,
    },
    64: {
        regular: KonturMercuryIcon64Regular,
    },
};
export var KonturMercuryIcon = forwardRef('KonturMercuryIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
